import React from 'react'
import {Section} from './ARStyledComponents'
import AdminReservationTimelineView, {AdminTimelineItem} from '../../AdminReservationTimelineView'
import moment from 'moment'
import {Id} from '../../../components/ReservationTimelineView'
import {convertToFacilityId} from '../../../helpers/helpers'
import {FullWidthRightRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import { Box, Paper } from '@mui/material';

export interface DurationFacilityReserveAvailability {
    id: number
    name: string
    timeLineItems: AdminTimelineItem[]
}

interface Props {
    areaWidth: number
    facilities: DurationFacilityReserveAvailability[]
    activeDay: moment.Moment
    initialVisibleStartDateTime: moment.Moment
    limitStartDateTime: moment.Moment
    limitEndDateTime: moment.Moment
    onClickName?: (facilityId: number) => void
    onClickTimeline?: (facilityId: number, reservation: Id | null, time: moment.Moment) => void
}

const ARReservationStatusViewDuration: React.FC<Props> = props => {
    const {
        areaWidth, facilities, onClickName, onClickTimeline, initialVisibleStartDateTime,
        activeDay, limitStartDateTime, limitEndDateTime
    } = props

    if (facilities.length === 0) {
        return null
    }

    return <>
        <Box mt={'15px'}>
            <Section>時間貸し施設</Section>
        </Box>
        <FullWidthRightRowFlexContainer>
            <BlankLegend>空きあり</BlankLegend>
            <OutOfHoursLegend>時間外</OutOfHoursLegend>
            <OtherReservationsLegend>予約あり(予約不可)</OtherReservationsLegend>
        </FullWidthRightRowFlexContainer>
        <Box mt={'5px'}>
            <Paper>
                <AdminReservationTimelineView
                    activeDay={activeDay}
                    initialVisibleStartDateTime={initialVisibleStartDateTime}
                    limitStartDateTime={limitStartDateTime}
                    limitEndDateTime={limitEndDateTime}
                    areaWidth={areaWidth}
                    onTimelineClick={(groupId: Id, itemId: Id | null, time: moment.Moment) => {
                        if (!onClickTimeline) {
                            return
                        }
                        const facilityId = convertToFacilityId(groupId)
                        onClickTimeline(facilityId, itemId, time)
                    }}
                    onGroupClick={(groupId: Id) => {
                        if (!onClickName) {
                            return
                        }
                        const facilityId = convertToFacilityId(groupId)
                        onClickName(facilityId)
                    }}
                    groups={facilities.map(facility => {
                        return {id: facility.id, title: facility.name}
                    })}
                    items={facilities.map(facility => facility.timeLineItems).flat()}
                    sidebarProps={{pcWidth: 245, spWidth: 245}}
                />
            </Paper>
        </Box>
    </>
}

ARReservationStatusViewDuration.displayName = 'ARReservationStatusViewDuration'
export default ARReservationStatusViewDuration

const StatusLegend = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 15px;
  height: 12px;
  line-height: 1;

  &::before {
    content: '';
    height: 12px;
    width: 12px;
    display: inline-block;
    margin-right: 3px;
  }
`

const BlankLegend = styled(StatusLegend)`
  &::before {
    background: #FFFFFF;
    border: solid 1px #d9d9d9;
  }
`

const OtherReservationsLegend = styled(StatusLegend)`
  &::before {
    background: rgb(141, 141, 141);
    border: solid 1px #707070;
  }
`

const OutOfHoursLegend = styled(StatusLegend)`
  &::before {
    background: rgb(225, 225, 225);
    border: solid 1px #d9d9d9;
  }
`
